// extracted by mini-css-extract-plugin
export default {"container":"mobileMenu_container__bguIG","expandTab":"mobileMenu_expandTab__wrmUG","newCollection":"mobileMenu_newCollection__+CVBR","skew":"mobileMenu_skew__IDEc+"};